import React from "react";
import styles from "./BlogSkeleton.module.css";

const BlogSkeleton: React.FC = () => {
  return (
    <div
      className={styles.blogSkeletonContainer}
      aria-busy="true"
      aria-label="Cargando blog"
    >
      {/* Banner skeleton */}
      <div className={styles.bannerSkeleton}>
        <div className={styles.bannerContentSkeleton}>
          <div className={styles.bannerTitleSkeleton} />
          <div className={styles.searchBoxSkeleton} />
        </div>
      </div>

      {/* Collections skeleton */}
      <div className={styles.collectionsContainer}>
        {/* Only one collection for skeleton */}
        <div className={styles.collectionSkeleton}>
          <div className={styles.collectionTitleSkeleton} />
          <div className={styles.articlesRowSkeleton}>
            {Array(3)
              .fill(0)
              .map((_, index) => (
                <div
                  key={index}
                  className={styles.articleCardSkeleton}
                  role="status"
                  aria-label="Cargando artículo"
                >
                  <div className={styles.articleImageSkeleton} />
                  <div className={styles.articleContentSkeleton}>
                    <div className={styles.articleCategorySkeleton} />
                    <div className={styles.articleTitleSkeleton} />
                    <div className={styles.articleExcerptSkeleton} />
                    <div className={styles.articleAuthorSkeleton}>
                      <div className={styles.authorAvatarSkeleton} />
                      <div className={styles.authorNameSkeleton} />
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogSkeleton;
